import { PlatformType, ZoomConfig } from "../types";
import { ZOOM_CONFIG } from "../config";

/**
 * =====================================================
 * 平台检测工具函数
 * =====================================================
 */

/**
 * 检测当前操作系统
 * 优先使用 userAgentData (现代浏览器)，回退到 userAgent
 */
export const detectPlatform = (): PlatformType => {
  const platform =
    (navigator as any).userAgentData?.platform ||
    navigator.userAgent;

  const platformLower = String(platform).toLowerCase();

  if (platformLower.includes("mac") || platformLower.includes("darwin")) {
    return "mac";
  }
  if (platformLower.includes("win")) {
    return "windows";
  }
  return "linux";
};

/**
 * 获取当前平台的缩放配置
 */
export const getCurrentZoomConfig = (): ZoomConfig => {
  const platform = detectPlatform();
  return ZOOM_CONFIG[platform];
};

/**
 * 检查是否按下了缩放修饰键
 * 根据当前平台检测：
 * - Mac: Cmd 键
 * - Windows: Ctrl 键 或 Alt 键
 * - Linux: Ctrl 键
 */
export const isZoomModifierPressed = (evt: WheelEvent | MouseEvent): boolean => {
  const config = getCurrentZoomConfig();

  // 检查主修饰键
  if (evt[config.modifierKey]) {
    return true;
  }

  // 检查辅助修饰键（如 Windows 的 Alt 键）
  if (config.altKey && evt[config.altKey]) {
    return true;
  }

  // 检查辅助修饰键（如 Mac 的 Ctrl 键）
  if (config.ctrlKey && evt[config.ctrlKey]) {
    return true;
  }

  return false;
};

/**
 * 获取当前平台的缩放快捷键提示
 * @returns "Cmd + 滚轮" 或 "Ctrl + 滚轮"
 */
export const getZoomShortcutHint = (): string => {
  const config = getCurrentZoomConfig();
  return config.label;
};

/**
 * 获取当前平台类型
 * @returns "mac" | "windows" | "linux"
 */
export const getCurrentPlatform = (): PlatformType => {
  return detectPlatform();
};
